import React from 'react'
import styled from '@emotion/styled'
import { Button } from '@mobi/component-library/Base/Buttons'
import { spacing } from '@mobi/component-library/Foundations'
import { Icon } from '@mobi/component-library/Legacy/Icon'
import { SpinnerInlineStyled } from '@mobi/component-library/Legacy/Spinner/Spinner.styles'
import { useAddToBlackbook } from '@core/Areas/Blackbook/Hooks/useAddToBlackbook'
import { getIconName } from '@core/Areas/Blackbook/helpers'

export const BlackbookButton: React.FC<BlackbookParams> = ({
  starterName,
  starterType,
  entryType,
  source,
  isReady,
}) => {
  const { matchedRunnerInBlackbook, isPending, clickHandler } = useAddToBlackbook({
    starterName,
    starterType,
    source,
  })

  const isRunnerInBlackbook = Boolean(matchedRunnerInBlackbook)

  const iconName = isRunnerInBlackbook ? 'tickCircleSolid' : getIconName(starterType)

  return (
    <Button
      color={isRunnerInBlackbook ? 'primary' : 'secondary_color'}
      size='xs'
      isFullWidth
      onClick={() => clickHandler('runners')}
      disabled={isPending || !isReady}
    >
      <InnerButtonStyled>
        {!isReady || isPending ? (
          <SpinnerInlineStyled color='dark' size={2} />
        ) : (
          <>
            <Icon
              type={iconName}
              size={entryType === 'Jockey' || isRunnerInBlackbook ? '1.6rem' : '2rem'}
              color='currentColor'
            />

            {isRunnerInBlackbook ? ` See ${entryType}` : ` Add ${entryType}`}
          </>
        )}
      </InnerButtonStyled>
    </Button>
  )
}

// ======
// Styles
// ======

const InnerButtonStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: spacing.smx1,
})

// =====
// Types
// =====

type BlackbookParams = Parameters<typeof useAddToBlackbook>[0] & {
  isReady: boolean
  entryType: 'Runner' | 'Jockey'
}
